import {useState} from 'react'
import MenuItem from '@material-ui/core/MenuItem';

import {
    FILTER_ALL, FILTER_NO_BARCODE,
    FILTER_NO_CATEGORY,
    FILTER_NO_COVER, FILTER_NO_INTERNAL_ID,
    FILTER_NOT_VALID,
    FILTER_VALID
} from '../../redux/ActionType/ActionType';
import {TextField} from "@mui/material";
import {isFunction} from "lodash";


const OPTIONS = [
    {value: FILTER_ALL, label: 'Tout'},
    {value: FILTER_VALID, label: 'Validé'},
    {value: FILTER_NOT_VALID, label: 'Non validé'},
    {value: FILTER_NO_COVER, label: 'Aucune image'},
    {value: FILTER_NO_CATEGORY, label: 'Pas de categorie'},
    {value: FILTER_NO_BARCODE, label: 'Pas de code barre'},
    {value: FILTER_NO_INTERNAL_ID, label: 'Pas d ID ProSoft'},
]

export const MenuValidation = ({setValidationStatus}) => {

    const [first] = OPTIONS;
    const [selected, setSelected] = useState(first.value);

    const handleChange = (change) => {
        setSelected(change)
        isFunction(setValidationStatus) && setValidationStatus(change)
    }

    return (
        <>
            <TextField
                fullWidth
                select
                label={'Filtre'}
                value={selected}
                style={{minWidth:300}}
                onChange={ev => handleChange(ev.target.value)}
            >

                {
                    OPTIONS.map(one => (
                        <MenuItem key={one.value} value={one.value}>
                            {one.label}
                        </MenuItem>
                    ))
                }

            </TextField>

        </>
    )
}
